/**
 * Parse numeric money fields from command dashboard API (e.g. "4280.00").
 * @param {unknown} value
 * @returns {number}
 */
export function parseDashboardMoney(value) {
  const parsed = Number(String(value ?? '').replace(/,/g, ''))

  return Number.isFinite(parsed) ? parsed : 0
}

/**
 * @param {Record<string, unknown> | null | undefined} meta
 * @returns {Date}
 */
export function dashboardBusinessDate(meta) {
  const raw = meta?.business_date

  if (typeof raw === 'string' && raw.length >= 10) {
    const parsed = new Date(`${raw}T12:00:00`)

    if (!Number.isNaN(parsed.getTime())) {
      return parsed
    }
  }

  return new Date()
}
